import { selectedOptionId } from '@mgo/core/src/validations/coac';

export default {
  selectedOptionId,
};
